<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="活动ID" prop="activityId" >
        <a-input v-model="form.activityId" placeholder="请输入活动ID" />
      </a-form-model-item>
      <a-form-model-item label="任务ID" prop="taskId" >
        <a-input v-model="form.taskId" placeholder="请输入任务ID" />
      </a-form-model-item>
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="剧本ID" prop="scriptId" >
        <a-input v-model="form.scriptId" placeholder="请输入剧本ID" />
      </a-form-model-item>
      <a-form-model-item label="领取金额" prop="claimAmount" >
        <a-input v-model="form.claimAmount" placeholder="请输入领取金额" />
      </a-form-model-item>
      <a-form-model-item label="领取时间" prop="claimTime" >
        <a-date-picker style="width: 100%" v-model="form.claimTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="商家转账订单状态" prop="claimStatus" >
      </a-form-model-item>
      <a-form-model-item label="发起商家转账响应数据" prop="responseData" >
        <a-input v-model="form.responseData" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="商家转账回调通知数据" prop="notifyData" >
        <a-input v-model="form.notifyData" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="逻辑删除标记" prop="isDeleted" >
        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="乐观锁" prop="version" >
        <a-input v-model="form.version" placeholder="请输入乐观锁" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRebateClaimRecord, addRebateClaimRecord, updateRebateClaimRecord } from '@/api/played/rebateClaimRecord'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        activityId: null,
        taskId: null,
        userId: null,
        scriptId: null,
        claimAmount: null,
        claimTime: null,
        claimStatus: '0',
        responseData: null,
        notifyData: null,
        createTime: null,
        updateTime: null,
        creator: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        activityId: [
          { required: true, message: '活动ID不能为空', trigger: 'blur' }
        ],
        taskId: [
          { required: true, message: '任务ID不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        scriptId: [
          { required: true, message: '剧本ID不能为空', trigger: 'blur' }
        ],
        claimAmount: [
          { required: true, message: '领取金额不能为空', trigger: 'blur' }
        ],
        claimTime: [
          { required: true, message: '领取时间不能为空', trigger: 'blur' }
        ],
        claimStatus: [
          { required: true, message: '商家转账订单状态不能为空', trigger: 'blur' }
        ],
        responseData: [
          { required: true, message: '发起商家转账响应数据不能为空', trigger: 'blur' }
        ],
        notifyData: [
          { required: true, message: '商家转账回调通知数据不能为空', trigger: 'blur' }
        ],
        isDeleted: [
          { required: true, message: '逻辑删除标记不能为空', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '乐观锁不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        activityId: null,
        taskId: null,
        userId: null,
        scriptId: null,
        claimAmount: null,
        claimTime: null,
        claimStatus: '0',
        responseData: null,
        notifyData: null,
        createTime: null,
        updateTime: null,
        creator: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRebateClaimRecord(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRebateClaimRecord(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRebateClaimRecord(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
